var Config = /** @class */ (function () {
    function Config() {
    }
    Config.LS_EVENTS_QUEUE = "eventsqueue";
    Config.LS_DOMAIN_ID = "did";
    Config.LS_BROWSER_ID = "bid";
    Config.QUERY_PARAM_BROWSER_ID = "bid";
    // Query param a communication link click can carry an encrypted reveal
    // identity in (see PidReveal.ts / core-api's link-rewriter.ts).
    Config.QUERY_PARAM_PID = "pid";
    Config.SERVER_URL = __CDP_SERVER_URL__;
    // Base URL of core-api, which serves the public personalize delivery
    // endpoint (/personalize/serve). Distinct from SERVER_URL (core-input, which
    // ingests events). Overridable at runtime via window.Tracker.apiUrl.
    Config.API_URL = __CDP_API_URL__;
    // How often the queue is flushed.
    Config.SEND_INTERVAL = 1000;
    // How long a single request is given before it is aborted. Deliberately a
    // separate, much larger number: this used to be SEND_INTERVAL itself, so any
    // request that took longer than one second — routine on mobile networks —
    // was aborted client-side, its events put back on the queue and sent again a
    // second later, even though core-input had already received and processed
    // them. Every slow request duplicated its events, repeatedly. 15s is longer
    // than any healthy round trip and still short enough to give up on a
    // genuinely dead connection.
    Config.SEND_TIMEOUT = 15000;
    Config.LS_SESSION_ID = 'sid';
    Config.LS_TOPICS_SENT_FLAG = 'topicsSent';
    Config.GDPR_CONSENT_VAR = "cdpfGdprConsent";
    // localStorage key for the structured consent state (ConsentManager)
    Config.LS_CONSENT_KEY = "cdpf_consent";
    // localStorage key for the timestamp (ms) ConsentManager last emitted a
    // `consent` event for, used to decide when a forced resync is due.
    Config.LS_CONSENT_SYNCED_AT = "cdpf_consent_synced_at";
    // Max interval between `consent` events even when nothing changed, so the
    // server-side proof-of-consent record doesn't go stale across many page
    // loads with no decision change. ~6 months.
    Config.CONSENT_RESYNC_INTERVAL_MS = 182 * 24 * 60 * 60 * 1000;
    // localStorage key prefix for the anagraphic-traits send cache: avoids
    // re-sending identical user traits on every login (client half of the
    // "once a week" double guard). Value stored is the last-sent timestamp.
    Config.LS_USER_TRAITS_CACHE = "cdpf_user_traits";
    // Min interval (ms) between re-sending identical user traits: 7 days.
    Config.USER_TRAITS_TTL = 7 * 24 * 60 * 60 * 1000;
    // data-attribute marking a node injected by the personalize feature, so a
    // re-render (SPA navigation) can clean up its own previous injections.
    Config.PERSONALIZE_MARKER = "data-cdpf-personalize";
    // data-attribute an AI/human-authored personalization can put on its own
    // close/dismiss control (e.g. a "×" button) so the tracker — not any inline
    // script, which never runs since the markup is injected via innerHTML — can
    // wire up actually removing the component on click.
    Config.PERSONALIZE_CLOSE_MARKER = "data-cdpf-close";
    // localStorage key for the last-shown timestamp of each personalization,
    // keyed by componentId -> ms epoch, used to suppress re-showing a component
    // still within its server-configured cooldown window.
    Config.LS_PERSONALIZE_LAST_SHOWN = "cdpf_personalize_shown";
    // data-attributes the server's `link` placeholder stamps on a recommended CTA
    // anchor, so a click on it can be attributed to the recommendation (and item).
    Config.RECO_MARKER = "data-cdpf-reco";
    Config.RECO_ITEM_MARKER = "data-cdpf-item";
    // localStorage key for the A/B experiment assignments the visitor was exposed
    // to, keyed by personalizationId -> { variantId, recommendationId?, ts }. Read
    // when a purchase happens to attribute the conversion (last-touch) to the
    // variant the visitor saw.
    Config.LS_EXPERIMENT_ASSIGNMENTS = "cdpf_experiments";
    // Conversion attribution window (ms): a purchase counts towards a variant only
    // if the visitor was exposed to it within this window. 7 days.
    Config.EXPERIMENT_ATTRIBUTION_TTL = 7 * 24 * 60 * 60 * 1000;
    // data-attribute the Form Builder stamps on the root <form> of a rendered
    // form (core-api forms/form-html.generator.ts) — the selector FormSubmit
    // uses to find injected forms and read the id to submit with. Value is the
    // form_templates id.
    Config.FORM_ID_ATTR = "data-cdpf-form-id";
    // localStorage key prefix marking an ad-platform match id (gclid, fbp, ...)
    // already sent for this device, so it isn't re-identified on every pageview.
    Config.LS_AD_MATCH_ID_SENT = "cdpf_ad_match_id_sent";
    return Config;
}());
export default Config;
